import apiClient from "./http";

export const createPaymentIntent = (payload) =>
  apiClient.post("/Billing/pay", payload);

export const getStatus = () => apiClient.get("/billing/status");

export const getUsage = () => apiClient.get("/Billing/usage");
